import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { HandspraySiteDetail } from 'src/app/models/handspray.model';
import { AuthService } from 'src/app/services/auth.service';
import { GpsCoord } from 'src/app/models/core.model';

@Component({
  selector: 'app-handspray-site',
  templateUrl: './handspray-site.component.html',
  styleUrls: ['./handspray-site.component.scss']
})
export class HandspraySiteComponent implements OnInit {

  site: HandspraySiteDetail;
  zoom: 14;
  center: GpsCoord = {lat: 0, lng: 0};

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.site = data.site;
      this.site.latitude = Number(this.site.latitude);
      this.site.longitude = Number(this.site.longitude);
      this.center.lat = this.site.latitude;
      this.center.lng = this.site.longitude;
    });
  }

}
